import CheckIcon from '@mui/icons-material/Check';
import AIButton, { AIButtonProps } from './AIButton';

export const AICheckButton = ({ ...rest }: AIButtonProps) => (
  <AIButton
    size="small"
    text=""
    variant="contained"
    showIcon={false}
    sx={{
      minWidth: 0,
      padding: 0,
      width: '24px',
      height: '24px',
      borderRadius: '6px',
    }}
    {...rest}
  >
    <CheckIcon />
  </AIButton>
);
